import { useEffect, useState } from 'react';
import type { TextareaField } from '@aquilixshop/ui-react';
import { FieldRow } from '../FieldRow';

export function TextareaControl({
  field,
  value,
  onChange,
}: {
  field: TextareaField;
  value: string | undefined;
  onChange: (next: string) => void;
}) {
  const [local, setLocal] = useState(value ?? '');
  useEffect(() => setLocal(value ?? ''), [value]);

  const counter = field.maxLength ? `${local.length}/${field.maxLength}` : undefined;

  return (
    <FieldRow id={field.id} label={field.label} info={field.info} counter={counter}>
      <textarea
        id={field.id}
        className="bld-textarea"
        rows={field.rows ?? 3}
        value={local}
        placeholder={field.placeholder}
        maxLength={field.maxLength}
        onChange={(e) => {
          setLocal(e.target.value);
          onChange(e.target.value);
        }}
      />
    </FieldRow>
  );
}
